module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/suspended-dark-8ffc4395a06ac272bcd5e20b8c7d5f2b.png";